import LogtoClient from "@logto/browser";

const logtoClient = new LogtoClient({
  endpoint: process.env.LOGTO_ENDPOINT,
  appId: process.env.LOGTO_APP_ID,
});

const header_cta = document.getElementById("header_cta");
const footer_cta = document.getElementById("footer_cta");
const hero_cta = document.getElementById("hero_cta");
const start_trial_pro = document.getElementById("start_trial_pro");
const start_trial_ent = document.getElementById("start_trial_ent");
const start_now_free = document.getElementById("start_now_free");

var toggleOpen = document.getElementById("toggleOpen");
var toggleClose = document.getElementById("toggleClose");
var collapseMenu = document.getElementById("collapseMenu");

function handleClick() {
  if (collapseMenu.style.display === "block") {
    collapseMenu.style.display = "none";
  } else {
    collapseMenu.style.display = "block";
  }
}

toggleOpen.addEventListener("click", handleClick);
toggleClose.addEventListener("click", handleClick);

const signUp = () => {
  logtoClient.signIn({
    redirectUri: process.env.LOGTO_REDIRECT_URL,
    firstScreen: "register",
  });
};

header_cta.addEventListener("click", signUp);
hero_cta.addEventListener("click", signUp);
footer_cta?.addEventListener("click", signUp);

start_trial_pro?.addEventListener("click", signUp);
start_trial_ent?.addEventListener("click", signUp);
start_now_free?.addEventListener("click", signUp);
